var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.300781 11.5339C0.300986 9.29562 0.954643 7.10625 2.18136 5.23503C3.40807 3.3638 5.15435 1.89231 7.20541 1.00155C9.25647 0.110789 11.5229 -0.160404 13.7259 0.221327C15.9288 0.603058 17.9723 1.62107 19.605 3.15014C21.2377 4.67922 22.3884 6.65269 22.9155 8.82782C23.4426 11.0029 23.3232 13.2849 22.572 15.393C21.8207 17.5011 20.4704 19.3434 18.6871 20.6933C16.9037 22.0432 14.7652 22.8419 12.5344 22.9912V13.8302H15.5928V12.2993H12.5344V10.0029C12.5344 9.39391 12.7761 8.80983 13.2062 8.37918C13.6364 7.94852 14.2199 7.70659 14.8282 7.70659H15.5928V6.17568H14.8282C13.8143 6.17568 12.8419 6.57891 12.1249 7.29666C11.408 8.01441 11.0052 8.98789 11.0052 10.0029V12.2993H7.9468V13.8302H11.0052V22.9912C8.10208 22.797 5.38119 21.5054 3.39366 19.3781C1.40612 17.2507 0.300515 14.4467 0.300781 11.5339Z",
    fill: "#2B2B2B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSf);
export default __webpack_public_path__ + "static/media/sf.a6081de8cb016dcd8f467348f827be21.svg";
export { ForwardRef as ReactComponent };